import React, { useEffect } from 'react';
import { SUBTITLE_LANG_LABELS } from '../constants/subtitleLanguages';
import { subtitleDebug } from '../utils/subtitleDebug';

const cleanSubtitleUrl = (url) => (url ? String(url).replace(/\?$/, '') : '');

const SubtitleTracks = ({ subtitleMap = {} }) => {
  useEffect(() => {
    subtitleDebug('SubtitleTracks', 'rendering <track> elements', {
      langs: Object.keys(subtitleMap),
      urls: subtitleMap,
    });
  }, [subtitleMap]);

  return Object.entries(subtitleMap).map(([lang, url]) => (
    <track
      key={`${lang}-${url}`}
      kind="subtitles"
      src={cleanSubtitleUrl(url)}
      srcLang={lang}
      label={SUBTITLE_LANG_LABELS[lang] || lang}
    />
  ));
};

export default SubtitleTracks;
